import React from 'react'
import logo from '../logo.png'
import {Message, Form, Segment, Button} from 'semantic-ui-react'
import {createAPIClient} from '../../../services/api'
import {browserHistory} from 'react-router'

export default class ChangePassword extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      error: undefined,
      password: '',
      confirm_password: '',
      isLoading: false
    }
  }

  onFieldChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  submit () {
    if (this.state.password !== this.state.confirm_password){
      this.setState({error: 'Passwords are not matching'})
      this.setState({password: '', confirm_password: ''})
      return
    }
    const api = createAPIClient()
    const form = {password: this.state.password, id: this.props.userId, reset_link: this.props.resetLink}
    this.setState({isLoading: true})
    api.put('/auth/resetpassword', form)
      .then(results => {
        this.setState({isLoading: false})
        browserHistory.push('/auth?reset=true')
      })
      .catch(error => {
        this.setState({error: 'Token expired please resubmit request', password: '', confirm_password: '', isLoading: false})
      })
  }

  render () {
    let errorNode

    if (this.state.error) {
      errorNode = <Message negative>{this.state.error}</Message>
    }
    return (
      <div>
        <img style={{'display': 'block', 'maxWidth': '60%', 'margin': '2em auto'}} src={logo} alt='Factoripad' />
        <Segment>
          <Form loading={this.state.isLoading} onSubmit={this.submit.bind(this)}>
            <h2>Reset password</h2>
            {errorNode}
            <Form.Field>
              <label htmlFor='password'>New password</label>
              <input autoFocus onChange={this.onFieldChange.bind(this)} type='password' id='password' name='password'
                     value={this.state.password} />
            </Form.Field>

            <Form.Field>
              <label htmlFor='confirm_password'>Confirm new password</label>
              <input autoFocus onChange={this.onFieldChange.bind(this)} type='password' id='confirm_password' name='confirm_password'
                     value={this.state.confirm_password} />
            </Form.Field>
            <Button primary type='submit'>Change password</Button>
          </Form>
        </Segment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/resetpassword/changepassword/index.js